export default {
  name: "app-footer",
  components: {},
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },
  methods: {}
};
